<div class="flex min-h-screen justify-center bg-evenlightergrey px-6 pb-6">
    <div class="w-full max-w-lg pt-8">
        <h1 class="text-center">Sign Up</h1>
        <app-user-register></app-user-register>

        <p class="mt-10 mb-5 text-center">Already have an account?</p>
        <app-cta-button
            [link]="['/sign-in']"
            variant="secondary"
            [additionalClasses]="['w-full']"
            >Sign In</app-cta-button
        >
    </div>
</div>
